import { SlotGameType1_21 } from '../SlotGameType1_21';

export class SevenFeverClassic21 extends SlotGameType1_21
{
}
